import { useEffect, useState } from 'react'
import { useFormRicercaConSalvataggioFiltri, FormRicerca, BaseSelect, BaseContenutoConProgress } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'

const NOMI = {
  NOME_DB: 'nomeDb',
}

const DEFAULT_VALUES_CRITERI = {
  [NOMI.NOME_DB]: '',
}

const CHIAVE_SALVATAGGIO_LETTURA_DB = 'chiaveSalvataggioLetturaDb'

export default function FormLetturaDb(props) {
  const { setRisultati, ...restProps } = props

  const [nomiDb, setNomidb] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  const propsFormRicerca = useFormRicercaConSalvataggioFiltri({
    chiaveSalvataggio: CHIAVE_SALVATAGGIO_LETTURA_DB,
    optionsSalvataggio: { chiaveRottaPadreInCuiMantenere: CHIAVI_ROUTES.READ_DB },
    defaultValues: DEFAULT_VALUES_CRITERI,
    setDatiRicerca: setRisultati
  })

  useEffect(() => {
    async function getNomiDb() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.NOMI_DB)
      if (ok && data.esito) setNomidb(data.data.map((value) => ({
        value: value,
        label: value,
      })))
    }
    getNomiDb()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {ScatolaMessaggi}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {nomiDb &&
          <FormRicerca
            operationIdRicerca={OPERAZIONI.READ_DB}
            {...propsFormRicerca}
            titolo='Dati db'
            conScatola={false}
            {...restProps}
          >
            <BaseSelect
              label='Nomi db' name={NOMI.NOME_DB}
              options={[{ value: '', label: '' }, ...nomiDb]}
              required
            />
          </FormRicerca>
        }
      </BaseContenutoConProgress>
    </>
  )
}